import {createTheme} from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        h1: {
          fontSize: '1.5rem',
          fontWeight: 700
        }
      }
    }
  },
  palette: {
    primary: {
      main: '#0076A5'
    },
    secondary: {
      main: '#ED6C02'
    },
    success: {
      main: '#4CAF50'
    },
    background: {
      default: "#eeeeee"
    }
  },
});

export default theme;
